var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.results.length >= 6)?_c('div',{staticClass:"nav-search-more-results",on:{"click":_vm.moreResults}},[_vm._v(" Ver todos los resultados ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }